'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M37.548 21.54c0 10.005-8.11 18.115-18.114 18.115-10.004 0-18.115-8.11-18.115-18.114 0-10.005 8.11-18.115 18.115-18.115 10.004 0 18.114 8.11 18.114 18.115",
    fill: "currentColor",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M11.667 29H45v18.667H11.667zM18.524 15.667l22.095.89 7.62 5.98v1.13l-39.62 1.27z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M37.571 16.557v1.246l3.81 4.573v1.8h-1.524v-1.248l-3.81-4.572v-1.8h1.524Zm-5.333 0v1.398l1.524 4.573v1.648h-1.524v-1.402l-1.524-4.57v-1.647h1.524Zm-9.905 0v1.8l-3.81 4.57v1.249H17v-1.8l3.81-4.573v-1.246h1.523Zm5.334 0v1.647l-1.524 4.57v1.402h-1.524v-1.648l1.524-4.573v-1.398h1.524ZM9.38 11.985v1.524H1v-1.524h8.381ZM13.629 1c1.81 0 3.445 1.027 4.311 2.579l.028.052.123-.021c.07-.01.139-.017.208-.022l.21-.007c1.056 0 2.06.58 2.699 1.403l.105.144h4.83v1.524h-5.724l-.213-.415c-.32-.63-1.032-1.133-1.697-1.133-.17 0-.347.032-.534.094l-.143.052-.723.289-.273-.73c-.507-1.35-1.789-2.285-3.207-2.285-1.59 0-3.322 1.873-3.423 3.248l-.004.12-.002.76H3.286V5.128H8.77l.028-.116c.508-1.922 2.539-3.91 4.667-4.008L13.63 1Zm-1.2 10.985v1.524h-1.524v-1.524h1.524ZM40.196 1.792c1.285 0 2.445.56 3.195 1.515l.035.046.05-.002c1.305-.024 2.322.501 2.934 1.64l.07.137H49v1.524h-3.57l-.178-.513c-.344-.995-.937-1.343-1.975-1.253l-.144.016-.499.06-.252-.434c-.439-.757-1.246-1.212-2.186-1.212-1.519 0-2.46.82-2.532 2.412l-.004.167-.005.757H33V5.128h3.192l.026-.156c.35-1.954 1.806-3.112 3.8-3.177l.178-.003ZM29.19 5.128v1.524h-1.523V5.128h1.523ZM46.048 25.381v22.095h-1.334V25.381z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M45 47.667H11.667v-1.334H45zM9 47.667H5v-1.334h4zM2.333 47.667H1v-1.334h1.333zM49 47.667h-1.333v-1.334H49z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M17.762 16.557h22.857v-5.334H17.762z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M41.381 10.461H17v6.857h24.381v-6.857Zm-1.524 1.524v3.81H18.524v-3.81h21.333Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.143 24.557v4.363c0 1.886 1.836 3.637 3.81 3.637 1.973 0 3.809-1.751 3.809-3.637 0 1.886 1.836 3.637 3.81 3.637s3.809-1.751 3.809-3.637c0 1.886 1.836 3.637 3.81 3.637S33 30.806 33 28.92c0 1.886 1.836 3.637 3.81 3.637s3.809-1.751 3.809-3.637c0 1.886 1.836 3.637 3.81 3.637s3.81-1.751 3.81-3.637v-4.363H10.142",
    fill: "#E9EAE6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M40.877 15.795H17.504l-8.123 6.204v6.748c0 2.396 2.177 4.571 4.571 4.571l.163-.003c1.4-.057 2.709-.849 3.53-1.98l.117-.167.007.011c.843 1.258 2.278 2.14 3.802 2.14l.163-.004c1.4-.057 2.709-.849 3.53-1.98l.117-.167.007.011c.843 1.258 2.278 2.14 3.802 2.14l.163-.004c1.4-.057 2.709-.849 3.53-1.98l.117-.167.007.011c.843 1.258 2.279 2.14 3.803 2.14l.162-.004c1.4-.057 2.709-.849 3.53-1.98l.117-.167.007.011c.843 1.258 2.279 2.14 3.803 2.14 2.395 0 4.571-2.176 4.571-4.572v-6.748l-8.123-6.204Zm-.515 1.523 7.114 5.434v5.995c0 1.554-1.494 3.048-3.047 3.048-1.554 0-3.048-1.494-3.048-3.048h-1.524c0 1.554-1.494 3.048-3.047 3.048-1.554 0-3.048-1.494-3.048-3.048h-1.524c0 1.554-1.494 3.048-3.048 3.048-1.553 0-3.047-1.494-3.047-3.048h-1.524c0 1.554-1.494 3.048-3.048 3.048-1.553 0-3.047-1.494-3.047-3.048H17c0 1.554-1.494 3.048-3.048 3.048l-.14-.004c-1.502-.087-2.907-1.537-2.907-3.044v-5.995l7.113-5.434h22.344Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M49 25H11.667v-1.333H49z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.284 47.033c.337-8.771 8.743-10.96 8.743-18.148a9.254 9.254 0 0 0-10.45-9.176c-4.823.606-8.387 4.987-8.028 9.836.493 6.672 8.392 8.991 8.718 17.488h1.017",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.483 18.953c-5.222.656-9.083 5.39-8.694 10.648.183 2.48 1.15 4.318 3.29 6.934l1.24 1.477.492.596c2.536 3.111 3.572 5.245 3.695 8.454l.028.733h2.483l.028-.733c.127-3.31 1.225-5.475 3.937-8.75l1.256-1.494c2.5-3.003 3.55-5.047 3.55-7.933 0-5.941-5.13-10.575-11.081-9.957l-.224.025Zm9.782 9.932c0 2.364-.848 4.09-2.98 6.695l-1.472 1.755c-2.247 2.712-3.495 4.779-4.014 7.29l-.024.119-.022-.119c-.52-2.511-1.768-4.578-4.015-7.29l-1.254-1.491-.42-.515c-1.819-2.259-2.606-3.817-2.755-5.84-.33-4.45 2.948-8.47 7.364-9.024 5.133-.644 9.592 3.319 9.592 8.42Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.714 28.752a3.05 3.05 0 0 1-3.047 3.053 3.05 3.05 0 0 1-3.048-3.053 3.05 3.05 0 0 1 3.048-3.053 3.05 3.05 0 0 1 3.047 3.053",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.667 24.938a3.812 3.812 0 0 0-3.81 3.814 3.812 3.812 0 0 0 3.81 3.814 3.812 3.812 0 0 0 3.81-3.814 3.812 3.812 0 0 0-3.81-3.814Zm0 1.523a2.288 2.288 0 0 1 2.285 2.291 2.288 2.288 0 0 1-2.285 2.29 2.288 2.288 0 0 1-2.286-2.29 2.288 2.288 0 0 1 2.286-2.29Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M33.762 47.033h7.619V36.366h-7.62z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M42.143 35.604H33v12.19h9.143v-12.19Zm-1.524 1.524v9.143h-6.095v-9.143h6.095Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M21.571 43.223h9.143v-6.857h-9.143z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.476 35.604H20.81v8.381h10.666v-8.38Zm-1.524 1.524v5.333h-7.619v-5.333h7.62Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  })));
});
var RealtyCommercial = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyCommercial = RealtyCommercial;